






















import { Vue } from "vue-property-decorator";
import { putFile, downloadGET } from "@/api/api";
import { getImg, downloadFile } from "@/utils";
import { cloneDeep, get } from "lodash";
import {
  ROfOssFile,
  ServiceProxy as ResourceServiceProxy,
} from "@/service-proxies/app-v2/resource.service-proxies";
const resourceService = new ResourceServiceProxy();

export default Vue.extend({
  name: "AppUploadImg",
  model: {
    prop: "value",
    event: "changeFileList",
  },
  props: {
    value: {
      type: Array,
    },
    limit: {
      // 限制的图片大小，默认为5MB
      type: Number,
      default: 5,
    },
    defaultList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      fileList: [],
      uploadList: [],
    };
  },
  watch: {
    defaultList: {
      handler(val) {
        this.fileList = [];
        this.fileList = val.map((item: any, i) => {
          return {
            ...item,
            uid: String(new Date().getTime()) + i,
            name: item.fileName ? item.fileName : "default",
            status: "done",
            url: "",
          };
        });
        console.log(666, this.uploadList);
        this.uploadList = val.map((item) => ({
          ...item,
          filename: item.fileName,
        }));
        this.$emit("changeFileList", this.uploadList);
      },
      immediate: true,
      deep: true,
    },
    uploadList: {
      async handler(val) {
        let temp = await this.getImgList();
        this.fileList.map((file, i) => {
          file.url = temp[i];
        });
        this.fileList = cloneDeep(this.fileList);
      },
      deep: true,
    },
  },
  methods: {
    preview(val) {
      downloadGET(val.objectKey, val.objectKey, val.contentType).then(
        (res: any) => {
          downloadFile(res, val.fileName);
        }
      );
    },
    // 生成预览图片
    async getImgList() {
      let fns = [];
      this.uploadList.map(async (item, index, arr) => {
        fns.push(getImg(item));
      });
      return await Promise.all(fns);
    },
    beforeUpload(file: any) {
      const isGt5M = file.size / 1024 / 1024 > this.limit;
      if (isGt5M) {
        let msg = (this.$t("page_tpm_repair_upload_limit") as string).replace(
          "{0}",
          "5"
        );
        this.$message.error(msg);
        return false;
      }
    },
    handleRemoveImg(info: any) {
      let delIndex = this.fileList.findIndex((file) => file.uid === info.uid);
      this.fileList.splice(delIndex, 1);
      if (info.objectKey) {
        // 此前上传成功的数据
        let i = this.uploadList.findIndex(
          (file) => file.objectKey === info.objectKey
        );
        this.uploadList.splice(i, 1);
      }
    },
    uploadImage(req) {
      let uploadFile = req.file;
      let fileOriginalName = uploadFile.name;
      this.fileList.push(uploadFile);
      uploadFile.status = "uploading";

      if (!this.fileList) {
        this.$message.success(this.$t("page_my_document_select"));
      }

      const formData = new FormData();
      formData.append("file", uploadFile);

      putFile(
        formData,
        (res) => {
          uploadFile.status = "done";

          let fileName = res.data.data.name;
          resourceService
            .statFileUsingGET(fileName)
            .then((statRes: ROfOssFile) => {
              let ossFile = statRes.data;
              console.log(6666, ossFile);
              this.uploadList.push({
                contentType: ossFile.contentType,
                originalFilename: fileOriginalName,
                filename: ossFile.name,
                objectKey: ossFile.name,
                link: ossFile.link,
              });
              console.log(7, this.uploadList);
            });
        },
        (err: any) => {
          uploadFile.status = "error";
        }
      ).finally(() => {
        this.$forceUpdate();
      });
    },
  },
});
